import axios from 'axios';

import { CONFIG } from '../constants/routes';

const configService = async () => {
  const artifactoryOrigin = (window._env_?.ARTIFACTORY_ORIGIN || '').replace(
    /\/$/,
    ''
  );
  const configUrl = artifactoryOrigin
    ? artifactoryOrigin + '/theme/config.json'
    : CONFIG;
  const response = await axios.get(configUrl);
  return response.data;
};

export default configService;
